var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavouriteStarred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.157 17.194l-5.79-4.04-5.903 3.89 2.25-6.487L0 6.418l7.18.03L9.553 0l2.189 6.506 7.179.154-5.828 3.99 2.065 6.544z",
    fill: "#A28D50",
    fillOpacity: 0.7
  })));
}

export default SvgFavouriteStarred;